/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholders_Phonenumber1Inputs */

const en_placeholders_phonenumber1 = /** @type {(inputs: Placeholders_Phonenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`000 00000`)
};

/**
* | output |
* | --- |
* | "000 00000" |
*
* @param {Placeholders_Phonenumber1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const placeholders_phonenumber1 = /** @type {((inputs?: Placeholders_Phonenumber1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_Phonenumber1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_phonenumber1(inputs)
});
export { placeholders_phonenumber1 as "placeholders_phoneNumber" }